<div class="grid-wrapper">
  <app-notification-container></app-notification-container>
  <div class="top-row">
    <div class="left-group">
      <select class="batch-select" (change)="filterByBatch($event)">
        <option value="">Select Batch</option>
        <option *ngFor="let batch of batches" [value]="batch">{{ batch }}</option>
      </select>
      <div class="search">
        <i class="bi bi-search"></i>
        <input class="quick-filter-input" type="text" placeholder="Search..."
          (input)="onFilterTextBoxChanged($event)" />
      </div>
      <div *ngIf="isLoading;" class="loading-message">
        {{ loadingMessage }} <div class="spinner"></div>
      </div>
    </div>
    <div class="right-group">
      <!-- Clear All Filters Button -->
      <div class="dropbtn" (click)="clearAllFilters()" title="Clear all filters">
        <i class="bi bi-x-circle"></i>
        Clear all filters
      </div>
    
      <!-- Tools Dropdown -->
      <div class="dropdown" #toolsDropdown>
        <div class="dropbtn" (click)="toggleDropdown('tools')">
          <i class="bi bi-tools"></i> Tools
          <i class="bi bi-chevron-up" *ngIf="isToolsDropdownOpen"></i>
          <i class="bi bi-chevron-down" *ngIf="!isToolsDropdownOpen"></i>
        </div>
        <div class="dropdown-content" *ngIf="isToolsDropdownOpen">
          <!-- Data Processing Tools Header -->
          <div class="dropdown-header">Data Processing Tools</div>
          <div class="dropdown-item" (click)="copySelectedRowsData()" title="Copy values from Legacy Data">
            <i class="bi bi-copy"></i> Copy values from Legacy Data
          </div>
          <div class="dropdown-item" (click)="addDelimiterToDescriptions()" title="Prepare Data for Parsing">
            <i class="bi bi-layout-split"></i> Prepare Data for Parsing
          </div>
          <div class="dropdown-item" (click)="parseDescriptions()" title="Parse Descriptions">
            <i class="bi bi-vr"></i> Parse Descriptions
          </div>
          <div class="dropdown-item" (click)="compareTypeParsedENFI()" title="Compare Parsed_Type_EN and FI">
            <i class="bi bi-c-square"></i> Compare Parsed_Type_EN and FI
          </div>
          <div class="dropdown-item" (click)="compareTypeSandParsedEN()" title="Compare Type_S and Parsed_Type_EN">
            <i class="bi bi-c-square"></i> Compare Type_S and Parsed_Type_EN
          </div>
          <div class="dropdown-item" (click)="generateDKBID()" title="Generate DKB_ID">
            <i class="bi bi-plus-square"></i> Generate DKB_ID
          </div>
          <div class="dropdown-item" (click)="generateDescriptions()" title="Generate Descriptions">
            <i class="bi bi-box-arrow-in-left"></i> Generate Descriptions
          </div>
          <div class="dropdown-item" (click)="validateSelectedData()" title="Validate Selected Data">
            <i class="bi bi-check-square"></i> Validate Selected Data
          </div>
          <div class="dropdown-item" (click)="openFindReplaceModal()" title="Find & Replace">
            <i class="bi bi-search"></i> Find & Replace
          </div>
    
          <!-- Export Options Header -->
          <div class="dropdown-header">Export Options</div>
          <div class="dropdown-item" (click)="onBtnExport('excel')" title="Export to Excel">
            <i class="bi bi-file-earmark-excel"></i> Export to Excel
          </div>
          <div class="dropdown-item" (click)="onBtnExport('csv')" title="Export to CSV">
            <i class="bi bi-file-earmark-text"></i> Export to CSV
          </div>
        </div>
      </div>
    
      <!-- Settings Dropdown -->
      <div class="dropdown" #settingsDropdown>
        <div class="dropbtn" (click)="toggleDropdown('settings')">
          <i class="bi bi-gear"></i> Settings
          <i class="bi bi-chevron-up" *ngIf="isSettingsDropdownOpen"></i>
          <i class="bi bi-chevron-down" *ngIf="!isSettingsDropdownOpen"></i>
        </div>
        <div class="dropdown-content" *ngIf="isSettingsDropdownOpen">
          <div class="switch-container">
            <span>Auto-Save:</span>
            <label class="switch">
              <input type="checkbox" [checked]="autoSaveEnabled" (change)="toggleAutoSave()" />
              <span class="slider round"></span>
            </label>
          </div>
          <div class="switch-container">
            <span>Pagination:</span>
            <label class="switch">
              <input type="checkbox" [checked]="isPaginationVisible" (change)="togglePaginationVisibility()" />
              <span class="slider round"></span>
            </label>
          </div>
        </div>
      </div>
    
      <!-- Save Changes Button -->
      <div class="icon-button" (click)="bulkUpdateData()" title="Save Changes">
        <i class="bi bi-floppy"></i>
      </div>
    
      <!-- Refresh Data Button -->
      <div class="icon-button" (click)="refreshFromDatabase()" title="Refresh Data">
        <i class="bi bi-arrow-clockwise"></i>
      </div>
    </div>
    
  </div>
  <div class="grid-container">
    <ag-grid-angular #agGrid style="width: 100%; height: 100%;" id="myGrid" class="ag-theme-alpine"
      [columnDefs]="colDefs" [defaultColDef]="defaultColDef" [rowData]="rowData" [rowSelection]="'multiple'"
      [animateRows]="true" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </div>
</div>

<!-- Find & Replace Modal -->
<div class="find-replace-modal-overlay" *ngIf="isFindReplaceModalOpen" (click)="closeFindReplaceModal()">
  <div class="find-replace-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>Find & Replace</h3>
      <button class="close-button" (click)="closeFindReplaceModal()">
        <i class="bi bi-x"></i>
      </button>
    </div>
    
    <div class="modal-body">
      <div class="search-info" *ngIf="selectedCells.length > 0">
        Searching within {{ selectedCells.length }} selected cells
      </div>
      
      <div class="form-group">
        <label for="findInput">Find what:</label>
        <input 
          id="findInput" 
          type="text" 
          [(ngModel)]="findValue" 
          (input)="findMatches()" 
          placeholder="Enter text to find"
          class="form-input"
        />
      </div>
      
      <div class="form-group">
        <label for="replaceInput">Replace with:</label>
        <input 
          id="replaceInput" 
          type="text" 
          [(ngModel)]="replaceValue" 
          placeholder="Enter replacement text"
          class="form-input"
        />
      </div>
      
      <div class="matches-info" *ngIf="findValue">
        <span *ngIf="totalMatches > 0">
          {{ currentMatchIndex + 1 }} of {{ totalMatches }} matches
        </span>
        <span *ngIf="totalMatches === 0 && findValue.trim()">
          No matches found
        </span>
      </div>
    </div>
    
    <div class="modal-footer">
      <button 
        class="btn btn-secondary" 
        (click)="findNext()" 
        [disabled]="!findValue.trim() || totalMatches === 0"
      >
        Find Next
      </button>
      
      <button 
        class="btn btn-primary" 
        (click)="replaceCurrent()" 
        [disabled]="currentMatchIndex < 0 || !findValue.trim()"
      >
        Replace
      </button>
      
      <button 
        class="btn btn-primary" 
        (click)="replaceAll()" 
        [disabled]="!findValue.trim() || totalMatches === 0"
      >
        Replace All
      </button>
      
      <button class="btn btn-secondary" (click)="closeFindReplaceModal()">
        Close
      </button>
    </div>
  </div>
</div>